// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IReturnMailOcrDetails } from './IReturnMailOcrDetails';
import {
    instanceOfIReturnMailOcrDetails,
    IReturnMailOcrDetailsFromJSON,
    IReturnMailOcrDetailsFromJSONTyped,
    IReturnMailOcrDetailsToJSON,
} from './IReturnMailOcrDetails';
import type { IReturnedCheckOcrDetails } from './IReturnedCheckOcrDetails';
import {
    instanceOfIReturnedCheckOcrDetails,
    IReturnedCheckOcrDetailsFromJSON,
    IReturnedCheckOcrDetailsFromJSONTyped,
    IReturnedCheckOcrDetailsToJSON,
} from './IReturnedCheckOcrDetails';

/**
 * @type IOcrLockboxDtoDetails
 * 
 * @export
 */
export type IOcrLockboxDtoDetails = IReturnMailOcrDetails | IReturnedCheckOcrDetails;

export function IOcrLockboxDtoDetailsFromJSON(json: any): IOcrLockboxDtoDetails {
    return IOcrLockboxDtoDetailsFromJSONTyped(json, false);
}

export function IOcrLockboxDtoDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrLockboxDtoDetails {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfIReturnMailOcrDetails(json)) {
        return IReturnMailOcrDetailsFromJSONTyped(json, true);
    }
    if (instanceOfIReturnedCheckOcrDetails(json)) {
        return IReturnedCheckOcrDetailsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function IOcrLockboxDtoDetailsToJSON(json: any): any {
    return IOcrLockboxDtoDetailsToJSONTyped(json, false);
}

export function IOcrLockboxDtoDetailsToJSONTyped(value?: IOcrLockboxDtoDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfIReturnMailOcrDetails(value)) {
        return IReturnMailOcrDetailsToJSON(value as IReturnMailOcrDetails);
    }
    if (instanceOfIReturnedCheckOcrDetails(value)) {
        return IReturnedCheckOcrDetailsToJSON(value as IReturnedCheckOcrDetails);
    }

    return {};
}

